import { api } from "@/lib/api";

const KEY = "process_pending_collections";

export function readQueue() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

export function writeQueue(items) {
  localStorage.setItem(KEY, JSON.stringify(items));
}

export function enqueue(item) {
  const q = readQueue();
  q.push({ ...item, _localId: `local-${Date.now()}-${Math.random().toString(36).slice(2, 8)}` });
  writeQueue(q);
}

export async function flushQueue(onItemSynced) {
  const q = readQueue();
  if (!q.length) return { synced: 0, remaining: 0 };
  const remaining = [];
  let synced = 0;
  for (const item of q) {
    try {
      const { _localId, ...payload } = item;
      const { data } = await api.post("/collections", payload);
      synced += 1;
      onItemSynced && onItemSynced(_localId, data);
    } catch {
      remaining.push(item);
    }
  }
  writeQueue(remaining);
  return { synced, remaining: remaining.length };
}
